import { isNil } from 'lodash-es';
import createNetworkingClient from 'utils/networking-client';
import { devLog } from 'utils/dev-utils';
import { useCallback } from 'react';

import { useFeedContext } from '../state/FeedContext';

const client = createNetworkingClient();

const cache = [];

const useFeedRitmoCapping = () => {
  const { entityState } = useFeedContext() || {
    entityState: {
      isRestoringScrollPosition: false
    }
  };
  const { isRestoringScrollPosition } = entityState;

  const errorState = (e) => {
    devLog(e);
    // TODO remove devLog and instead log error in sentry [monorepo]
  };

  const updateRitmo = useCallback(
    ({ elementId, path, promo, inView = true }) => {
      // do not track impressions for elements that are not in view and during feed scroll position restoration
      if (!inView || isRestoringScrollPosition) {
        return;
      }

      if (isNil(promo)) {
        errorState(new Error('promo name is required'));
        return;
      }
      if (isNil(elementId)) {
        errorState(new Error('element id is required'));
        return;
      }
      if (isNil(path)) {
        errorState(new Error('impression path is required'));
        return;
      }

      const key = `${promo}-${elementId}`;
      if (cache.includes(key)) {
        return;
      }

      client
        .post(path, {
          promo
        })
        .then((response) => {
          if (response.status === 200) {
            cache.push(key);
          } else {
            errorState(response.error);
          }
        })
        .catch((e) => {
          errorState(e);
        });
    },
    [isRestoringScrollPosition]
  );

  return { updateRitmo, cache };
};

export default useFeedRitmoCapping;
